import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Card, Table, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import CardItem from "./CardItem";
import "./style.scss";
import AddVacationsModal from "./AddVacationsModal";
import VacationRequestCardItem from "./VacationRequestCardItem";
import VacationExtensionCardItem from "./VacationExtensionCardItem";
import VacationCancellationCardItem from "./VacationCancellationCardItem";
import VacationsService from "../../../../services/HRM/VacationsService";
import VacationRequestService from "../../../../services/HRM/VacationRequestService";
import VacationExtensionService from "../../../../services/HRM/VacationExtensionService";
import VacationCancellationService from "../../../../services/HRM/VacationCancellationService";
import { Translate } from "../../../Enums/Tranlate";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import Pagination from "../../../common/Pagination/Pagination";

const Vacations = () => {
	const tabs = [
		"leave_balance",
		"vacations_requests",
		"vacation_extension_requests",
		"vacation_cancellation_requests",
	];
	const [data, setData] = useState([]);
	const [modal, setModal] = useState(false);
	const [selectTab, setSelectTab] = useState("leave_balance");
	const [item, setItem] = useState({});
	const [hasData, setHasData] = useState(null);
	const [search, setSearch] = useState(null);
	const [loading, setLoading] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);

	const [requestsData, setRequestsData] = useState([]);
	const [requestsLoading, setRequestsLoading] = useState(false);
	const [extensionsData, setExtensionsData] = useState([]);
	const [extensionsLoading, setExtensionsLoading] = useState(false);
	const [cancellationsData, setCancellationsData] = useState([]);
	const [cancellationsLoading, setCancellationsLoading] = useState(false);

	const lang = useSelector((state) => state.auth?.lang);
	const vacationsService = new VacationsService();

	useEffect(() => {
		if (selectTab !== "vacations_requests") return;
		setRequestsLoading(true);
		new VacationRequestService()
			.getList()
			.then((res) => {
				if (res?.status === 200) {
					setRequestsData(res?.data?.data || res?.data || []);
				}
			})
			.finally(() => setRequestsLoading(false));
	}, [selectTab]);

	useEffect(() => {
		if (selectTab !== "vacation_extension_requests") return;
		setExtensionsLoading(true);
		new VacationExtensionService()
			.getList()
			.then((res) => {
				if (res?.status === 200) {
					setExtensionsData(res?.data?.data || res?.data || []);
				}
			})
			.finally(() => setExtensionsLoading(false));
	}, [selectTab]);

	useEffect(() => {
		if (selectTab !== "vacation_cancellation_requests") return;
		setCancellationsLoading(true);
		new VacationCancellationService()
			.getList()
			.then((res) => {
				if (res?.status === 200) {
					setCancellationsData(res?.data?.data || res?.data || []);
				}
			})
			.finally(() => setCancellationsLoading(false));
	}, [selectTab]);

	const handleRequestStatusChange = (id, newStatus) => {
		setRequestsData((prev) =>
			prev.map((row) =>
				row.id === id
					? {
							...row,
							status: newStatus === "approve" ? "approved" : "rejected",
						}
					: row,
			),
		);
	};

	const handleExtensionStatusChange = (id, newStatus) => {
		setExtensionsData((prev) =>
			prev.map((row) =>
				row.id === id
					? {
							...row,
							status: newStatus === "approve" ? "approved" : "rejected",
						}
					: row,
			),
		);
	};

	const handleCancellationStatusChange = (id, newStatus) => {
		setCancellationsData((prev) =>
			prev.map((row) =>
				row.id === id
					? {
							...row,
							status: newStatus === "approve" ? "approved" : "rejected",
						}
					: row,
			),
		);
	};

	return (
		<Fragment>
			<Card className="mb-3">
				<Card.Body className="d-flex p-3 align-items-center justify-content-between">
					<div className="d-flex align-items-center">
						{tabs?.map((tab, index) => (
							<p
								key={index}
								className="mb-0 mx-2 cursor-pointer"
								style={{
									color: tab === selectTab ? "var(--primary)" : "#7E7E7E",
									borderBottom: tab === selectTab ? "2px solid" : "none",
								}}
								onClick={() => {
									setSelectTab(tab);
									setHasData(null);
								}}>
								{Translate[lang][tab]}
							</p>
						))}
					</div>
					{selectTab === "leave_balance" && (
						<Button
							variant="primary"
							className="me-2 h-75"
							onClick={() => {
								setItem({});
								setModal(true);
							}}>
							{Translate[lang]?.add} {Translate[lang]?.vacation}
						</Button>
					)}
				</Card.Body>
			</Card>

			{selectTab === "leave_balance" && (
				<Row>
					<Col lg={12}>
						<Card>
							<Card.Body className={`${hasData === 0 && "text-center"}`}>
								{loading && (
									<div style={{ height: "300px" }}>
										<Loader />
									</div>
								)}
								{hasData === 1 && !loading && (
									<Table responsive>
										<thead>
											<tr className="text-center">
												<th>
													<strong>I.D</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.employee_name}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.department}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.departure_day}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.return_day}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.reason}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.type}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.number_of_days}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.actions}</strong>
												</th>
											</tr>
										</thead>
										<tbody className="table-body">
											{data?.map((item, index) => (
												<CardItem
													index={index}
													key={index}
													item={item}
													setItem={setItem}
													setModal={setModal}
													setShouldUpdate={setShouldUpdate}
												/>
											))}
										</tbody>
									</Table>
								)}
								{hasData === 0 && <NoData />}
								<Pagination
									setData={setData}
									service={vacationsService}
									shouldUpdate={shouldUpdate}
									setHasData={setHasData}
									setLoading={setLoading}
									search={search}
								/>
							</Card.Body>
						</Card>
					</Col>
				</Row>
			)}

			{selectTab === "vacations_requests" && (
				<Row>
					<Col lg={12}>
						<Card>
							<Card.Body
								className={`${!requestsLoading && requestsData.length === 0 && "text-center"}`}>
								{requestsLoading && (
									<div style={{ height: "300px" }}>
										<Loader />
									</div>
								)}
								{!requestsLoading && requestsData.length > 0 && (
									<Table responsive>
										<thead>
											<tr className="text-center">
												<th>
													<strong>I.D</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.employee_name}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.department}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.departure_day}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.return_day}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.reason}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.type}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.number_of_days}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.status || "Status"}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.attachments}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.actions}</strong>
												</th>
											</tr>
										</thead>
										<tbody className="table-body">
											{requestsData.map((item, index) => (
												<VacationRequestCardItem
													index={index}
													key={item.id}
													item={item}
													onStatusChange={handleRequestStatusChange}
												/>
											))}
										</tbody>
									</Table>
								)}
								{!requestsLoading && requestsData.length === 0 && <NoData />}
							</Card.Body>
						</Card>
					</Col>
				</Row>
			)}

			{selectTab === "vacation_extension_requests" && (
				<Row>
					<Col lg={12}>
						<Card>
							<Card.Body
								className={`${!extensionsLoading && extensionsData.length === 0 && "text-center"}`}>
								{extensionsLoading && (
									<div style={{ height: "300px" }}>
										<Loader />
									</div>
								)}
								{!extensionsLoading && extensionsData.length > 0 && (
									<Table responsive>
										<thead>
											<tr className="text-center">
												<th>
													<strong>I.D</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.employee_name}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.department}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.departure_day}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.return_day}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.extend_to_date}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.additional_days}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.description}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.status || "Status"}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.attachments}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.actions}</strong>
												</th>
											</tr>
										</thead>
										<tbody className="table-body">
											{extensionsData.map((item, index) => (
												<VacationExtensionCardItem
													index={index}
													key={item.id}
													item={item}
													onStatusChange={handleExtensionStatusChange}
												/>
											))}
										</tbody>
									</Table>
								)}
								{!extensionsLoading && extensionsData.length === 0 && (
									<NoData />
								)}
							</Card.Body>
						</Card>
					</Col>
				</Row>
			)}

			{selectTab === "vacation_cancellation_requests" && (
				<Row>
					<Col lg={12}>
						<Card>
							<Card.Body
								className={`${!cancellationsLoading && cancellationsData.length === 0 && "text-center"}`}>
								{cancellationsLoading && (
									<div style={{ height: "300px" }}>
										<Loader />
									</div>
								)}
								{!cancellationsLoading && cancellationsData.length > 0 && (
									<Table responsive>
										<thead>
											<tr className="text-center">
												<th>
													<strong>I.D</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.employee_name}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.department}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.departure_day}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.return_day}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.description}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.status || "Status"}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.attachments}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.actions}</strong>
												</th>
											</tr>
										</thead>
										<tbody className="table-body">
											{cancellationsData.map((item, index) => (
												<VacationCancellationCardItem
													index={index}
													key={item.id}
													item={item}
													onStatusChange={handleCancellationStatusChange}
												/>
											))}
										</tbody>
									</Table>
								)}
								{!cancellationsLoading && cancellationsData.length === 0 && (
									<NoData />
								)}
							</Card.Body>
						</Card>
					</Col>
				</Row>
			)}

			{modal && (
				<AddVacationsModal
					modal={modal}
					item={item}
					setShouldUpdate={setShouldUpdate}
					setModal={() => setModal(false)}
				/>
			)}
		</Fragment>
	);
};

export default Vacations;
